export default (state = {}, action = null) => {
    switch (action.type) {
    default:
        return state;
    }
};
